<template>
  <div tabindex="0" :class="{ 'comment-card': type == 'pop' }">
    <div v-if="isBigPic" class="card-header">
      <div class="user-info-box">
        <div class="user-info-big">
          <div class="name">{{ userInfo.nickName }}</div>
          <div class="spec">{{ userInfo.specItem }}</div>
        </div>
      </div>
    </div>
    <div v-else class="card-header">
      <div class="user-info-box">
        <img v-lazy="userInfo.memberAvatar" alt="" class="avatar webp__disabled" />
        <div class="user-info">
          <div class="info">
            <span class="name">{{ userInfo.nickName }}</span>
            <i class="level-icon" :aria-label="userInfo.memberLevelName">
              <img class="level-icon-img" :src="userInfo.levelIconWithTextUrl" :alt="userInfo.memberLevelName">
            </i>
          </div>
          <div class="model" v-text="userInfo.specItem"></div>
        </div>
        <!-- 评分五角星 -->
        <div class="rate" :aria-label="`五星评价共${userInfo.score}星`">
          <rate :score="userInfo.score" :gradientFlag="false"></rate>
        </div>
      </div>
    </div>
    <div class="content" :class="`content-${isBigPic}`" v-if="userInfo.content">
      <p :class="type" @click="clickAction" v-html="userInfo.content"></p>
      <div v-if="isBigPic" class="shadow"></div>
    </div>
  </div>
</template>
<script>
import rate from '../rate'
export default {
  name: 'UserInfo',
  props: {
    isBigPic: {
      type: Boolean,
      default: false
    },
    userInfo: Object,
    // 来源 1表示商详页评价模块，2表示评价列表
    origin: Number,
    // 类型
    type: String
  },
  components: {
    rate
  },
  methods: {
    // 评价内容点击事件
    clickAction() {
      this.$emit('remarkContentClick')
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .card-header {
    .user-info-box {
      .user-info {
        .level-icon {
          &-img {
            height: 39px;
          }
        }
      }
    }
  }
}
.vivo-fontscale-5 {
  .card-header {
    .user-info-box {
      .user-info {
        .level-icon {
          &-img {
            height: 49px;
          }
        }
      }
    }
  }
}
</style>
